import { IStaffSchedule, IStaffScheduleListItem } from './schedule.types';
export default class StaffSchedule implements IStaffSchedule {

    default_from: string | null;
    default_to: string | null;
    data: IStaffScheduleListItem[] = [];

    constructor(data: IStaffSchedule) {

        this.default_from = data.default_from;
        this.default_to = data.default_to;
        
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}
